import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
const ZipField = t0 => {
  const $ = _c(27);
  let error;
  let handleBlur;
  let handleChange;
  let isTouched;
  let props;
  let t1;
  let t2;
  let t3;
  let updateShipping;
  let value;
  if ($[0] !== t0) {
    ({
      id: t1,
      name: t2,
      value,
      error,
      isTouched,
      handleBlur,
      handleChange,
      updateShipping,
      isRequired: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = error;
    $[2] = handleBlur;
    $[3] = handleChange;
    $[4] = isTouched;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = updateShipping;
    $[10] = value;
  } else {
    error = $[1];
    handleBlur = $[2];
    handleChange = $[3];
    isTouched = $[4];
    props = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    updateShipping = $[9];
    value = $[10];
  }
  const id = t1 === undefined ? "zipcode" : t1;
  const name = t2 === undefined ? "zipcode" : t2;
  const isRequired = t3 === undefined ? true : t3;
  let t4;
  if ($[11] !== handleChange) {
    t4 = evt => {
      if (/^\d{0,5}$/.test(evt.target.value) || evt.target.value === "") {
        handleChange(evt);
      }
    };
    $[11] = handleChange;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== error || $[14] !== handleBlur || $[15] !== updateShipping) {
    t5 = evt_0 => {
      handleBlur(evt_0);
      if (!error && updateShipping) {
        updateShipping();
      }
    };
    $[13] = error;
    $[14] = handleBlur;
    $[15] = updateShipping;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const t6 = isRequired ? "" : undefined;
  const t7 = isRequired ? "" : undefined;
  const t8 = isTouched && error ? error : null;
  let t9;
  if ($[17] !== id || $[18] !== name || $[19] !== props || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7 || $[24] !== t8 || $[25] !== value) {
    t9 = <LabeledTextInput id={id} name={name} maxLength="5" label="Zip code *" data-xc="shipping-zip-field" onChange={t4} onBlur={t5} value={value} autoComplete="postal-code" required={t6} aria-required={t7} {...props} errorMessage={t8} />;
    $[17] = id;
    $[18] = name;
    $[19] = props;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = value;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};
ZipField.propTypes = {
  error: PropTypes.string,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  id: PropTypes.string,
  isRequired: PropTypes.bool,
  isTouched: PropTypes.bool,
  name: PropTypes.string,
  updateShipping: PropTypes.func,
  value: PropTypes.string
};
export default ZipField;